import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogInComponent } from './log-in/log-in.component';
import { AppRoutingModule } from './app.routing.module';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { BuyTokensComponent } from './buy-tokens/buy-tokens.component';
import { ReferralsComponent } from './referrals/referrals.component';
import { ProfileSettingsComponent } from './profile-settings/profile-settings.component';
import { HeaderComponent } from './header/header.component';
import { MainComponent } from './main/main.component';
import { HttpModule } from '@angular/http';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { AlertModule } from 'ngx-alerts';
import {Ng2Webstorage} from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie-service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MailotpComponent } from './mailotp/mailotp.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UserIdleModule } from 'angular-user-idle';
import { NotfoundComponent } from './notfound/notfound.component';
import { KycComponent } from './kyc/kyc.component';
import { FooterComponent } from './footer/footer.component';
import { EmailactivationComponent } from './emailactivation/emailactivation.component';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { ResendactivationmailComponent } from './resendactivationmail/resendactivationmail.component';
import { AirdropComponent } from './airdrop/airdrop.component';
import { AirdropotpComponent } from './airdropotp/airdropotp.component';
// import { InputFileConfig, InputFileModule } from 'ngx';


// const config: InputFileConfig = {
//   fileAccept: '*',
//   fileLimit: 4
// };

@NgModule({
  declarations: [
    AppComponent,
    LogInComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    TransactionsComponent,
    BuyTokensComponent,
    ReferralsComponent,
    ProfileSettingsComponent,
    HeaderComponent,
    MainComponent,
    PurchaseOrderComponent,
    MailotpComponent,
    KycComponent,
    NotfoundComponent,
    FooterComponent,
    EmailactivationComponent,
    PasswordresetComponent,
    ResendactivationmailComponent,
    AirdropComponent,
    AirdropotpComponent,
    // InputFileModule.forRoot(config)
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    AppRoutingModule,
    Ng2Webstorage,
    UserIdleModule.forRoot({idle: 300, timeout: 5, ping: 180}),
    BrowserAnimationsModule,
    NgxSpinnerModule,
    AlertModule.forRoot({maxMessages: 5, timeout: 5000})
  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
